export default "__VITE_ASSET__18846326__"